// extracted by mini-css-extract-plugin
module.exports = {"container":"_2sWjIowJz1DXvihT-2nVTb"};